module.exports = "<div class=mdl-grid> <div class=\"title mdl-cell mdl-cell--12-col\"> {{ title }} </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
 ** module id = 32
 ** module chunks = 0
 **/